module.exports = __webpack_public_path__ + "static/cad-designs5-e39d9840d51f1e95e6aa1d310479c7aa.png";